/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-10-29 16:23:08
 * @LastEditors: liyong
 * @LastEditTime: 2022-08-11 13:45:03
 */
// 表单验证规则
import { isTel, isValidPriceReg, isWX, isDouYin, isPositiveInteger, isPositiveIntegerWithZero } from './reg';

//手机号验证
export const validateTel = (rule, value, callback) => {
	if (!value) {
		return callback(new Error('请输入手机号'));
	}
	setTimeout(() => {
		if (!isTel.test(value)) {
			callback(new Error('请输入正确的手机号'));
		} else {
			callback();
		}
	}, 200);
};
//字符长度限制
export const checkLength = (rule, value, callback) => {
	var l = 0;
	if (!value) {
		return callback(new Error('请输入姓名'));
	}
	if (!value) {
		return callback(new Error('请输入姓名'));
	}
	if (value.length > 25) {
		callback(new Error('输入不能超过25个字符！'));
	} else {
		callback();
	}
};
//文字限制长度
export const checkTextLength = (rule, value, callback) => {
	if (!value) {
		return callback(new Error('请输入姓名'));
	}
	if (value.length > 10) {
		callback(new Error('输入不能超过10个字符！'));
	} else {
		callback();
	}
};

//判断是否为图片
export const checkImg = val => {
	let fileText = val.slice(val.lastIndexOf('.'));
	let imgType = ['.png', '.jpg', '.jpeg', '.gif', '.webp', '.psd'];
	return imgType.indexOf(fileText.toLowerCase()) !== -1;
};

//判断是否保留小数点两位
export const checkPriceReg = (rule, value, callback) => {
	if (!value) {
		callback(new Error(rule.msg));
		return;
	}
	if (!isValidPriceReg.test(value)) {
		callback(new Error('保留小数点两位'));
	} else {
		callback();
	}
};

// 微信号
export const checkWx = (_, value, callback) => (isWX.test(value) || !value ? callback() : callback(new Error('请输入合法的微信号')));

// 抖音号
export const checkDouYin = (_, value, callback) =>
	isDouYin.test(value) ? callback() : callback(new Error('最多16个字，只允许包含字母、数字、下划线和点'));

// 手机号
export const checkMobile = (_, value, callback) => (isTel.test(value) || !value ? callback() : callback(new Error('请输入正确的手机号')));

//判断当前日期和传入的日期大小
export const todayCheck = value => {
	var myDate = new Date();
	var now = myDate.valueOf();
	var time = new Date(new Date(value).getTime() + 24 * 60 * 60 * 1000 - 1).valueOf();
	if (now >= time) {
		return true;
	} else {
		return false;
	}
};

export const checkIsInt = (rule, value, callback) => {
	if (!value) {
		callback(new Error('请输入'));
		return;
	}
	if (!isPositiveInteger.test(value)) {
		callback(new Error(rule.msg));
	} else {
		callback();
	}
};

export const checkIsIntWidthZero = (rule, value, callback) => {
	if (value === '') {
		callback();
		return;
	}
	if (!isPositiveIntegerWithZero.test(value)) {
		callback(new Error(rule.msg));
	} else {
		callback();
	}
};

export const checkPromotionProtect = (rule, value, callback) => {
	if (value === '') {
		callback();
		return;
	}
	if (value < 0 || value > 6) {
		callback(new Error(rule.msg));
	} else {
		callback();
	}
};
export const checkTalentCommission = (rule, value, callback) => {
	if (value === '') {
		callback();
		return;
	}
	if (value < 5 || value > 80) {
		callback(new Error(rule.msg));
	} else {
		callback();
	}
};
export const checkServiceFeeRate = (rule, value, callback) => {
	if (value === '') {
		callback();
		return;
	}
	if (value < 1 || value > 84.5) {
		callback(new Error(rule.msg));
	} else {
		callback();
	}
};

//输入为数字且保留小数字 num 位
export const checkInputNumber = (value, num = 2) => {
	let check = {
		1: /\d+\.?\d{0,1}/,
		2: /\d+\.?\d{0,2}/,
		3: /\d+\.?\d{0,3}/,
	};
	return `${value.match(check[num])}`;
};

//‌校验15位字母加数字
export const isValidnum15 = (rule, value, callback) => {
	if (!value) {
		callback(new Error('请输入视频号ID'));
		return;
	}
	if (!/^[A-Za-z0-9]+$/.test(value)) {
		callback(new Error('请输入字母加数字'));
		return;
	} else if (value.length > 18) {
		callback(new Error('最多18位'));
		return;
	} else {
		callback();
	}
};
